module.exports = __webpack_public_path__ + "static/media/Kuva_3_2.f2ff5b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_3_2.png
// module id = 1397
// module chunks = 0